import { useTranslation } from 'libs/i18n';
import { Button, Stack, Typography } from 'libs/ui';

import { ConfirmationDialogContentProps } from '../types';

import { ContainerStyled } from './ConfirmationDialogContent.styles';

export const ConfirmationDialogContent = ({
  title,
  subtitle,
  confirmButtonLabel,
  confirmButtonDisabled,
  backButtonLabel,
  onConfirm,
  onBack,
  children,
  loading,
  headerCentered,
  buttonConfirm,
  hideButtonConfirm,
  hideBackButton,
  confirmButtonColorVariant,
}: ConfirmationDialogContentProps) => {
  const { t } = useTranslation();

  const ButtonConfirm = buttonConfirm ?? Button;

  return (
    <ContainerStyled>
      <Stack spacing={32}>
        <Stack
          alignItems={headerCentered ? 'center' : undefined}
          as="header"
          spacing={12}
        >
          <Typography align="center" as="h3" variant="header">
            {title}
          </Typography>
          {!!subtitle && (
            <Typography
              align={headerCentered ? 'center' : undefined}
              className="confirmDialog-subtitle"
              variant="bodyMedium"
            >
              {subtitle}
            </Typography>
          )}
        </Stack>

        {children}

        <Stack spacing={8}>
          {!hideButtonConfirm && (
            <ButtonConfirm
              fullWidth
              colorVariant={confirmButtonColorVariant}
              disabled={confirmButtonDisabled}
              label={confirmButtonLabel ?? t('common.confirm')}
              loading={loading}
              onClick={onConfirm}
            />
          )}
          {!hideBackButton && (
            <Stack alignItems="center">
              <Button
                label={backButtonLabel ?? t('common.back')}
                mode="text"
                onClick={onBack}
              />
            </Stack>
          )}
        </Stack>
      </Stack>
    </ContainerStyled>
  );
};
